import { CLASSIFICATION_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import { getPageTypeFromPathname } from "../../helpers/helpers";
import { EventData, EventPayload } from "../../types";

export interface GeolocationHeroViewedPayload extends EventPayload {
  message: {
    title: string;
    body: string;
  };
  cta_labels: string;
}

const GeolocationHeroViewedAnalyticsEvent: EventData = {
  pageDetail: "",
  pageType: getPageTypeFromPathname(),
  eventName: "Geolocation Hero Viewed",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createGeolocationHeroViewedTrackEventPayload = () => {
  return eventPagePayloadCreator<GeolocationHeroViewedPayload>(
    GeolocationHeroViewedAnalyticsEvent,
  );
};
